import * as React from 'react';
import styled from 'styled-components';
import colors from '../colors';

const StyledButton = styled.button<{
  size?: any;
  level?: any;
  primaryColor?: any;
  actionElementColor?: any;
  actionElementFamily?: any;
  theme?: any;
}>`
  margin: 0;
  overflow: visible;
  text-transform: none;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  border: none;
  transition: background-color var(--transition-xs, 0.2s) ease-in-out,
              opacity var(--transition-xs, 0.2s) ease-in-out;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  &:focus-visible {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }
  
  ${({ size }) =>
    size === 'large'
      ? `padding: 0.5rem 1rem; font-size: 1.25rem;`
      : size === 'small'
      ? `padding: 0.25rem 1rem; font-size: 0.875rem;`
      : ``}

  ${({ level, theme, primaryColor }) =>
    level === 'primary' && theme === 'light'
      ? `background-color: ${primaryColor || '#007bff'};
         color: ${colors.white};
         border-color: transparent;
         opacity: 0.85;
         &:hover, &:active, &:focus { opacity: 1; }`
      : level === 'primary' && theme === 'dark'
      ? `background-color: ${primaryColor || '#007bff'};
         color: ${colors.white};
         border-color: transparent;
         opacity: 0.85;
         &:hover, &:active, &:focus { opacity: 1; }`
      : `background-color: ${primaryColor || '#007bff'}; 
         color: ${colors.white}; 
         border: none; 
         &:hover, &:active, &:focus { opacity: 1; }`}
`;


export interface Props {
  readonly level?: ButtonLevelType;
  readonly size?: SizeType;
  readonly text?: any;
  readonly onClick?: (e?) => void;
  readonly id?: string;
  readonly disabled?: boolean;
  readonly before?: React.ReactNode;
  readonly after?: React.ReactNode;
  readonly className?: string;
  readonly type?: ButtonType;
  readonly style?: object;
  readonly theme?: ThemeType;
  readonly primaryColor?: string;
  readonly actionElementColor?: string;
  readonly actionElementFamily?: string;
}

export type ThemeType = 'light' | 'dark';
export type ButtonType = 'button' | 'submit' | 'reset';
export type SizeType = 'large' | 'medium' | 'small';
export type ButtonLevelType = 'primary' | 'secondary' | 'tertiary';

const Button: React.FunctionComponent<Props> = ({
  text = '',
  size = 'medium',
  className = '',
  type = 'submit',
  theme = 'light',
  disabled,
  onClick,
  before,
  after,
  style,
  level = 'primary', // Default to primary button
  primaryColor = '#007bff', // Default blue color for Done button
  actionElementColor = '',
  actionElementFamily = '',
  ...args
}) => (
  <StyledButton
    level={level}
    size={size}
    theme={theme}
    className={className || ''}
    onClick={onClick}
    aria-label={text}
    disabled={disabled}
    type={type}
    style={style}
    primaryColor={primaryColor}
    actionElementColor={actionElementColor}
    actionElementFamily={actionElementFamily}
    {...args}
  >
    {before ? before : null} {text} {after ? after : null}
  </StyledButton>
);


export default Button;
